export default class CoreCP {

    constructor() {
        this.previewType = 0;
        this.workingSvg = null;
        this.boardSvg = null;
        this.workingSvgPadding = 15;
        this.calcSvg = null;
        this.elements = [];
        this.container = null;
        this.helperLine = null;
        this.width = 0;
        this.elementMaxWidth = 3050;
        this.height = 0;
        this.elementMaxHeight = 2050;
        this.scale = 1;
        this.gridScale = 5;
        this.snap2grid = false;
        this.mainShape = null;
        this.mainShapePolygon = null;
        this.mainShapePolygonPoints = null;
        this.fonts = [];
        this.mainShapeLimitHoleArea = false;
        this.chekIfHoleInMainShape = true;

        this.changeCallback = null;
        this.clickCallback = null;

        this.axisLines = {
            x : null,
            y : null,
            xText : null,
            yText : null,
        };
        this.translations = null;
        this.mobile = false;

    }

    callChangeCallback(element) {

        if (typeof this.changeCallback === 'function') {
            this.changeCallback(element);
        }
    }

    callClickCallback(element) {

        if (typeof this.clickCallback === 'function') {
            this.clickCallback(element);
        }
    }
}